import { FC } from 'react'
import { typography } from '@lifedot/styles/typography'

export interface PrefectureAndCityProps {
  prefecture: string
  city: string
}

export const PrefectureAndCity: FC<PrefectureAndCityProps> = ({
  prefecture,
  city
}) => {
  return (
    <p css={typography.textS}>
      {prefecture} / {city}
    </p>
  )
}
